import { api } from './api';

export interface ProductClientListParams {
  productId: number;
  search?: string;
  planId?: number;
  stage?: string;
  page?: number;
  limit?: number;
  includeSystemAccounts?: boolean;
  systemAccounts?: 'hide' | 'include' | 'only';
  optOut?: 'exclude' | 'only' | 'all';
}

export const productClientsService = {
  async list(params: ProductClientListParams) {
    const r = await api.get('/product-clients', { params });
    return r.data;
  },
  async stats(productId: number) {
    const r = await api.get('/product-clients/stats', { params: { productId } });
    return r.data;
  },
  async sync(productId: number) {
    // Send `{}` (not null) so body-parser strict mode doesn't reject the empty
    // payload with a SyntaxError that mimics JSON.parse ("Unexpected token 'n',
    // \"null\" is not valid JSON").
    const r = await api.post('/product-clients/sync', {}, { params: { productId } });
    return r.data;
  },
  async import(productId: number, file: File) {
    const form = new FormData();
    form.append('file', file);
    const r = await api.post('/product-clients/import', form, {
      params: { productId },
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return r.data;
  },
  async update(
    productId: number,
    id: number,
    data: { isSystemAccount?: boolean; marketingOptOut?: boolean }
  ) {
    const r = await api.patch(`/product-clients/${id}`, data, { params: { productId } });
    return r.data;
  },
};
